module.exports = __webpack_public_path__ + "static/crowdfunding-tablet-plp-13be68aa9226a01f635753028155f811.png";